import styled from 'styled-components';

import { ConfirmButton } from 'components/ui/Button';
import StyledSelect from 'components/ui/StyledSelect';
import Label from 'components/ui/Label';

import { colours } from 'themes/default';

const SubmitButton = styled(ConfirmButton)`
  margin: 0;
`;

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 16px 0;
`;

const StyledButton = styled.button.attrs({ type: 'button' })`
  border: none;
  text-decoration: underline;
  outline: none;
  cursor: pointer;
  padding: 0;
  line-height: 24px;
`;

const StyledDropdown = styled(StyledSelect)`
  height: 32px;
  margin-top: 16px;
`;

const StyledLabel = styled(Label)`
  margin-top: 16px;
  margin-bottom: 8px;
  text-transform: none;
`;

const StyledHeading = styled.h1`
  margin: 0;
`;

const StyledTextArea = styled.textarea`
  resize: none;
`;

const OverrideOptions = styled.div`
  display: flex;

  ${({ includeOverrides }) =>
    includeOverrides &&
    ` 
    background-color: ${colours.Greyscale.MistGrey};
    padding: 14px;

    ${SubmitButton} {
      margin-left: 40px;
    }
  `}
`;

export { SubmitButton, StyledForm, StyledButton, StyledDropdown, StyledLabel, StyledTextArea, StyledHeading, OverrideOptions };
